import { COPYRIGHT_ENGLISH } from "../constants.js";
export const ja = {
    "Notice": "Notice",
    "No slots available for the selected period.": "No slots available for the selected period.",
    "welcome_back": "お帰りなさい",
    "login_subtitle": "続行するにはサインインしてください。",
    "login_tos_prefix": "ログインすることで、あなたは当社の",
    "terms_of_service": "利用規約",
    "help": "ヘルプ",
    "privacy": "プライバシー",
    "imprint": "インプリント",
    "or": "または",
    "google": "Google",
    "sso_icon_alt": "SSO アイコン",
    "SSO": "SSO",
    "these_zesty_duck_nudge": "基本情報",
    "north_least_gopher_burn": "この予定タイプの目的は何ですか？",
    "lazy_just_duck_spin": "イベントタイトル",
    "Confirm meeting": "会議の確認",
    "Meeting with {{name}}": "{{name}} との会議",
    "Daily availability": "毎日の空き状況",
    "tiny_factual_platypus_pave": "会議はどこで行われますか？",
    "less_equal_octopus_dine": "URLのカスタマイズ可能な部分",
    "quiet_male_yak_slurp": "イベントスラッグ",
    "honest_weak_iguana_rest": "場所",
    "dizzy_quiet_walrus_hush": "素晴らしい会議",
    "tired_whole_bumblebee_type": "Zoom会議",
    "these_moving_fox_create": "説明",
    "quaint_known_wasp_view": "最小予約日前",
    "pretty_grand_cuckoo_arrive": "イベントはこの時間より前にスケジュールすることはできません",
    "slow_maroon_spider_praise": "1日あたりのこのタイプのイベントの最大数",
    "grand_wacky_ox_flow": "1日あたりの最大数",
    "left_aloof_stork_leap": "バッファー前",
    "elegant_early_boar_accept": "このイベントはどのくらいかかりますか？",
    "ideal_this_coyote_inspire": "期間",
    "jumpy_tasty_rook_trust": "期間",
    "real_big_crow_push": "このイベントの前のバッファー",
    "mealy_happy_ray_flop": "バッファー前",
    "close_actual_deer_boil": "バッファー後",
    "keen_zippy_bulldog_gaze": "このイベントの後のバッファー",
    "seemly_fine_octopus_slurp": "空き状況",
    "each_awake_tadpole_jest": "イベントタイプの編集",
    "extra_patient_warbler_praise": "予約するイベントがありません",
    "petty_swift_piranha_rise": "イベントをスケジュールする",
    "broad_close_butterfly_drop": "{{name}} との予定をスケジュールする",
    "weary_known_gazelle_file": "必要な予定のタイプを選択し、スケジュールボタンをクリックして予約してください。私のスケジュールの利用可能なスロットのリストが表示されます。",
    "low_clean_haddock_bubble": "私のイベントタイプ",
    "My Event Types": "私のイベントタイプ",
    "pink_trite_ocelot_enrich": "イベントを追加する前に、まずカレンダーを接続する必要があります！",
    "early_sweet_mantis_peek": "イベントタイプを追加",
    "deft_suave_bear_pause": "読み込み中",
    "equal_jolly_thrush_empower": " 分",
    "Schedule an appointment": "予定をスケジュールする",
    "heroic_kind_llama_zip": "戻る",
    "awake_jolly_gazelle_lock": "スキップ",
    "whole_acidic_parrot_promise": "予定を予約",
    "clear_close_racoon_pat": "{{value, dateTime}}",
    "cuddly_spare_felix_stir": "ステップ {{val}}",
    "extra_misty_panda_grip": "ユーザーはこのリンクを使用して予定を予約できます。",
    "sunny_great_halibut_empower": "最初の作成",
    "create_first_event_type_button": "イベントタイプ",
    "application_title": "Appoint Me",
    "orange_grand_racoon_fall": "{{app_title}}の仕組み",
    "male_patient_hedgehog_ask": "{{app_title}}はシンプルで使いやすい予約システムです。イベントを作成し、リンクを共有して、ユーザーがあなたと予定を予約できるようにします。",
    "factual_moving_hawk_belong": "{{app_title}}があなたの予定を追加する場所と、忙しいかどうかを確認する場所を指定します。",
    "step_1_configure_calendars": "ステップ1：カレンダーを設定",
    "pink_polite_racoon_earn": "ステップ2：イベントの作成",
    "happy_wise_mantis_laugh": "「利用可能な時間を追加すれば、準備完了です！」",
    "careful_misty_bullock_splash": "ステップ3：リンクを共有",
    "game_frail_vole_treasure": "完了！おめでとうございます！",
    "still_helpful_koala_trust": "ユーザーが予定を予約すると、イベントがカレンダーに追加されます。",
    "steep_fine_lobster_inspire": "イベントタイプの保存に失敗しました",
    "best_due_parakeet_zip": "イベントタイプが作成されました！",
    "happy_caring_fox_spur": "イベントが保存されました",
    "tasty_witty_stingray_hope": "イベントの保存エラー",
    "trite_warm_gorilla_pet": "カレンダーに予定を追加",
    "aware_alert_mare_glow": "カレンダーの空き時間を確認",
    "factual_nimble_snail_clap": "変更を保存",
    "tiny_teary_clownfish_vent": "キャンセル",
    "lower_born_finch_dash": "Googleから切断",
    "whole_formal_liger_rise": "Google Calendarを接続",
    "pink_loose_cougar_grin": "私のカレンダー",
    "upper_even_florian_peek": "Google Calendar",
    "merry_north_meerkat_cuddle": "設定",
    "big_known_loris_revive": "忙しい時間を確認するカレンダーを選択します。",
    "large_suave_gull_hush": "リンクをコピー",
    "misty_proud_mallard_assure": "リンクをコピー",
    "teal_lofty_hawk_peek": "キャンセル",
    "mild_raw_elk_delight": "変更を保存",
    "Choose date": "日付を選択",
    "Please select a date": "日付を選択してください",
    "Choose time": "時間を選択",
    "Provide details": "詳細を提供",
    "Confirmation": "確認",
    "Please share anything that will help me to prepare for our meeting": "会議の準備に役立つ情報を共有してください",
    "confirmationText_male": "{{date}} {{time}} に {{name}} と {{event}} の予定を予約しました。",
    "confirmationText_female": "{{date}} {{time}} に {{name}} と {{event}} の予定を予約しました。",
    "confirmationText_neuter": "{{date}} {{time}} に {{name}} と {{event}} の予定を予約しました。",
    "Name": "名前",
    "Please provide your name": "名前を入力してください",
    "Email": "メール",
    "Information": "情報",
    "You will receive a confirmation email": "確認メールが届きます",
    "Meeting with": "会議",
    "Change": "変更",
    "Back": "戻る",
    "Add Event Type": "イベントタイプを追加",
    "Confirm & Book": "確認して予約",
    "availableSlots": "{{date}} に以下のスロットが利用可能です。1つ予約するか、別の日を選択してください。",
    "minutes": "分",
    "Days": "日",
    "Maximum days in advance": "最大予約日前",
    "event_advance_availability_description": "このイベントタイプは何日前から利用可能ですか？",
    "none": "なし",
    "Select buffer": "バッファーを選択",
    "Save": "保存",
    "Select duration": "期間を選択",
    "Starttime": "開始時間",
    "Endtime": "終了時間",
    "Add Account": "アカウントを追加",
    "Add CalDav Account": "CalDavアカウントを追加",
    "CalDav Accounts": "CalDavアカウント",
    "Server URL": "サーバーURL",
    "Username": "ユーザー名",
    "label_password": "パスワード",
    "send_invitation_email": "Send invitation email",
    "send_invitation_email_notice": "Only needed if your CalDAV server does not send invitations automatically.",
    "invitationSubject": "招待：{{summary}}",
    "invitationBody": "<p>こんにちは {{attendeeName}}、</p><p>次のイベントに招待されました：</p><h3>{{summary}}</h3><p>{{description}}</p><p><strong>時間：</strong> {{time}}</p><p>イベントの詳細を添付します。</p>",
    "icsDescription": "イベントの説明：\n{{description}}",
    "dateFormat": "ja-JP",
    "user_menu_log_out": "Log out",
    "user_menu_log_in": "Log in",
    "user_menu_profile": "Profile",
    "user_menu_my_account": "My account",
    "user_menu_calendar_integration": "Calendar Integration",
    "user_menu_copy_link": "Copy your link",
    "user_menu_link_copied": "Link copied",
    "name": "名前",
    "user_url": "ユーザーURL",
    "use_gravatar": "Gravatarを使用",
    "save": "保存",
    "profile_updated": "プロファイルが正常に更新されました",
    "error_saving_profile": "プロファイルの保存エラー",
    "user_url_taken": "ユーザーURLは既に使用されています",
    "error_loading_profile": "プロファイルの読み込みエラー",
    "login_with_sso": "SSO でログイン",
    "login_with": "でログイン",
    "login_successful": "ログイン成功",
    "login_failed": "ログイン失敗",
    "google_login_failed": "Googleログイン失敗",
    "Add": "追加",
    "edit": "編集",
    "Close": "閉じる",
    "Choose calendars in which appointments are created.": "予定が作成されるカレンダーを選択します。",
    "Email (Optional)": "メール（オプション）",
    "Enter your CalDav server details to connect your calendar.": "カレンダーを接続するには、CalDavサーバーの詳細を入力してください。",
    "Failed to add account. Please check your credentials and server URL.": "アカウントを追加できませんでした。資格情報とサーバーURLを確認してください。",
    "I acknowledge that my password will be stored encrypted in the database.": "私のパスワードがデータベースに暗号化されて保存されることを認めます。",
    "event_copy_link": "リンクをコピー",
    "link_copied_to_clipboard": "リンクがクリップボードにコピーされました！",
    "link_copy_failed": "リンクをクリップボードにコピーできませんでした！",
    "copy": "コピー",
    "Availability Mode": "可用性モード",
    "Define Custom": "カスタム定義",
    "Use Standard": "標準を使用",
    "Standard + Extra": "標準 + 追加",
    "Standard + Constraints": "標準 + 制約",
    "Standard Availability": "標準の可用性",
    "Using Standard Availability defined in Profile settings.": "プロファイル設定で定義された標準の可用性を使用しています。",
    "Define your standard weekly availability here. You can use this availability in your Event Types.": "ここで標準の週次可用性を定義します。この可用性はイベントタイプで使用できます。",
    "Copy Standard Availability": "標準の可用性をコピー",
    "Overwrite current availability with standard?": "現在の可用性を標準で上書きしますか？",
    "Profile": "プロフィール",
    "about": "について",
    "about_content": "# AppointMeについて\n\nAppointMeは、予約スケジュールのためのシンプルなツールです。\nカレンダーを設定し、空き状況を決めれば、他の人があなたと予約を取れるようになります。\n\n## Github\n[Githubでコードを確認する](https://github.com/fhswf/appointme)\n\n## クレジット\n南ヴェストファーレン応用科学大学で❤️を込めて実装されました",
    "legal": "法的通知",
    "Calendar": "カレンダー",
    "Select a calendar": "カレンダーを選択",
    "No calendar selected": "カレンダーが選択されていません",
    "Calendar settings saved": "カレンダー設定が保存されました",
    "Failed to save settings": "設定の保存に失敗しました",
    "Failed to load calendars for": "カレンダーの読み込みに失敗しました",
    "Google Calendar disconnected": "Googleカレンダーが切断されました",
    "Failed to disconnect Google Calendar": "Googleカレンダーの切断に失敗しました",
    "Connect a calendar to get started": "開始するにはカレンダーを接続してください",
    "Online via Zoom": "Zoom経由のオンライン",
    "Language": "言語",
    "page not found": "ページが見つかりません",
    "GO HOME": "ホームへ",
    "Impressum": "法的通知",
    "Datenschutzhinweise": "プライバシーポリシー",
    "privacy_content": `
# プライバシーポリシー

## データの収集と利用
本アプリケーションは、予約スケジュールサービスを提供するために個人データを収集および利用します。

*   **ユーザープロファイル:** 私たちは、あなたを識別し、あなたの体験をパーソナライズするために、あなたの名前、メールアドレス、およびプロフィール写真を保存します。
*   **Googleユーザーデータ:** Googleカレンダーを接続する場合、以下の目的でカレンダーデータにアクセスします：
    *   重複予約を防ぐために空き状況を確認する。
    *   予約が行われたときにカレンダーに新しいイベントを作成する。
    *   私たちは、広告や市場調査などの他の目的であなたのGoogleカレンダーデータを利用することはありません。
*   **カレンダーデータ:** 接続されたカレンダーの設定、作成したイベントタイプ（名前、説明、場所）、および予約を保存します。
*   **ログデータ:** セキュリティとトラブルシューティングのために、IPアドレスはサーバーログファイルに一時的に保存されます。
*   **テレメトリ:** アプリケーションの安定性を向上させるために、Sentryを使用して匿名の使用状況データとエラーレポートを収集します。

## データの共有
サービスを提供するために必要な場合、または法律で要求される場合を除き、個人データを第三者と共有することはありません。

*   **Googleユーザーデータ:** Google APIから取得したデータは、カレンダー統合機能を提供するために必要な場合（例：Googleサーバーとの通信）を除き、サードパーティツール、AIモデル、または外部エンティティと**共有されません**。
*   **サービスプロバイダー:** サービスの安定性を確保するために、エラートラッキングとアプリケーション監視にSentryを使用しています。このプロバイダーは、サービスの提供のために厳密にIPアドレスおよびその他の技術データを処理する場合があります。
*   **ホスティング:** アプリケーションは、独自のインフラストラクチャ（Kubernetesクラスター）でホストされています。私たちは、データにアクセスできるサードパーティのCDNやホスティングプロバイダーを使用していません。

## データの保存と保護
あなたのデータは、私たちのサーバーに安全に保存されています。
*   **暗号化:** ブラウザとサーバー間で送信されるすべてのデータは、HTTPSを使用して暗号化されます。アクセストークンなどの機密データは、暗号化されてデータベースに保存されます。
*   **アクセス制御:** データへのアクセスは許可された担当者に制限されており、サポートまたはメンテナンスに必要な場合にのみアクセスされます。

## データの保持と削除
*   **保持:** アカウントがアクティブである限り、ユーザープロファイルとカレンダー設定データを保持します。予約データは、スケジュールされたイベントの履歴を提供するために保持されます。
*   **削除:** あなたは自分のデータの削除を要求する権利を持っています。アプリケーション設定からいつでもGoogleカレンダーを切断できます。これにより、Googleデータへのアクセスが削除されます。アカウントとデータの完全な削除を要求するには、gawron.christian@fh-swf.de までご連絡いただくか、プロフィール設定のアカウント削除機能を使用してください。

## Google APIサービスユーザーデータポリシー
AppointMeがGoogle APIから受け取った情報を他のアプリに使用および転送する場合、制限された使用要件を含む[Google APIサービスユーザーデータポリシー](https://developers.google.com/terms/api-services-user-data-policy)を遵守します。`,
    "privacy_content_public": `
# プライバシーポリシー

## データ処理

予約を目的として、このアプリケーションは提供されたデータ（名前、メールアドレス、説明、予約の日時）を処理します。このデータは予約を管理するために保存され、主催者のカレンダーと同期される場合があります。

## テレメトリ

アプリケーションの安定性を向上させるために、Sentryを使用して匿名のテレメトリデータとエラーレポートを収集します。`,
    "impressum_content": "# 法的通知\n\n## 免責事項\nこのサーバーのコンテンツは、南ヴェストファーレン応用科学大学の公式オンラインオファーの一部ではありません。",
    "CalDav Calendar": "CalDavカレンダー",
    "loading": "読み込み中...",
    "Legal": "法的通知",
    "new_event_type": "新しいイベントタイプ",
    "Appointment Summary": "予約の概要",
    "Could not book event": "予約できませんでした",
    "error_no_calendar": "カレンダー統合が設定されていません",
    "error_no_duration": "期間は0より大きくなければなりません",
    "error_no_slots": "時間枠が設定されていません",
    "Active": "有効",
    "Inactive": "無効",
    "delete": "削除",
    "Continue": "続行",
    "Book Appointment": "予約する",
    "Available Times": "利用可能な時間",
    "No slots available": "利用可能な枠がありません",
    "Schedule Appointment": "予約をスケジュールする",
    "Available Meeting Types": "利用可能な会議タイプ",
    "Please select a meeting type to view availability.": "空き状況を確認するには、会議タイプを選択してください。",
    "All": "すべて",
    "No public events found.": "公開イベントが見つかりません。",
    "Timezone": "タイムゾーン",
    "Privacy & Terms": "プライバシーと利用規約",
    "Quick": "クイック",
    "Consulting": "コンサルティング",
    "Tags": "タグ",
    "Type a tag and press Enter": "タグを入力してEnterキーを押してください",
    "Press Enter to add a tag": "Enterキーを押してタグを追加",
    "Cancel": "キャンセル",
    "landing_hero_title": "Appointment management <span class=\"text-primary\">made easy</span>",
    "landing_hero_subtitle": "Appoint Me is a simple and user-friendly solution for your appointments. Create events, share your link, and let others book appointments with you.",
    "landing_cta_start": "Start now",
    "landing_cta_learn_more": "Learn more",
    "landing_how_it_works_title": "How Appoint Me works",
    "landing_how_it_works_subtitle": "In just four simple steps to your organized calendar.",
    "landing_step1_title": "1. Configure calendar",
    "landing_step1_desc": "Determine where Appoint Me should enter appointments and where your availability should be checked. Connect your Google or Outlook calendar.",
    "landing_step2_title": "2. Create events",
    "landing_step2_desc": "Add your available times, define duration and break times, and get started!",
    "landing_step3_title": "3. Share your link",
    "landing_step3_desc": "Via your personal link, customers, colleagues, or friends can book appointments directly without annoying email ping-pong.",
    "landing_step4_title": "Done! Congrats!",
    "landing_step4_desc": "As soon as a user books an appointment, the event is automatically added to your calendar and both receive a confirmation.",
    "landing_footer_product": "Product",
    "landing_footer_features": "Features",
    "landing_footer_pricing": "Pricing",
    "landing_footer_integrations": "Integrations",
    "landing_footer_resources": "Resources",
    "landing_footer_documentation": "Documentation",
    "landing_footer_api": "API",
    "landing_footer_help_center": "Help Center",
    "landing_footer_legal": "Legal",
    "landing_footer_imprint": "Imprint",
    "landing_footer_privacy": "Privacy",
    "landing_footer_terms": "Terms & Conditions",
    "landing_footer_copyright": COPYRIGHT_ENGLISH,
    "landing_footer_tagline": "Simple appointment planning for everyone.",
    "Contact": "連絡先",
    "footer_credits": "南ヴェストファーレン応用科学大学で❤️を込めて実装されました",
    "terms_of_use_title": "Terms of Use",
    "terms_of_use_content": "# Terms of Use\n\n## Service Provision\n\nThis service is provided free of charge.\n\n## Disclaimer of Liability and Warranty\n\nNeither the authors nor the South Westphalia University of Applied Sciences accept any liability for damages of any kind or any warranty of any kind in connection with the use of this service. Use is at your own risk. This disclaimer does not apply to damages resulting from injury to life, body, or health based on an intentional or negligent breach of duty, nor to other damages based on an intentional or grossly negligent breach of duty.",
    "my_appointments": "私の予約",
    "no_upcoming_appointments": "今後の予約は見つかりませんでした。",
    "appointment": "予約",
    "attendee": "出席者",
    "appointment_details": "予約の詳細",
    "close": "閉じる",
    "event_type": "イベントタイプ",
    "week": "週",
    "work_week": "労働週",
    "day": "日",
    "month": "月",
    "today": "今日",
    "agenda": "アジェンダ",
    "more": "もっと",
    "next": "次へ",
    "back": "Back",
    "n_more": "他 {{count}} 件 ...",
    "Recurrence": "繰り返し",
    "Enable Recurring Event": "繰り返しイベントを有効にする",
    "Frequency": "頻度",
    "Weekly": "毎週",
    "Bi-weekly": "隔週",
    "Tri-weekly": "3週間ごと",
    "Monthly": "毎月",
    "End Condition": "終了条件",
    "Occurrences": "回数",
    "OR": "または",
    "Until Date": "終了日",
    "Time Span": "期間",
    "Months": "ヶ月",
    "Weeks": "週間",
    "Recurring Event": "定期イベント",
    "Recurring": "定期",
    "weekly": "毎週",
    "biweekly": "隔週",
    "triweekly": "3週間ごと",
    "monthly": "毎月",
    "Series Booking Note: Students will book all occurrences at once.": "定期予約の注記：学生はすべての回を一括で予約します。",
    "Feedback": "フィードバック",
    "Student Only": "学生のみ",
    "Restricted to Students": "学生限定",
    "Settings exported successfully": "設定が正常にエクスポートされました",
    "Failed to export settings": "設定のエクスポートに失敗しました",
    "Are you sure you want to import settings? This will overwrite your current profile and events.": "設定をインポートしてもよろしいですか？これにより、現在のプロファイルとイベントが上書きされます。",
    "Settings imported successfully": "設定が正常にインポートされました",
    "Failed to import settings": "設定のインポートに失敗しました",
    "Invalid file format": "無効なファイル形式",
    "Data": "データ",
    "Export Settings": "設定のエクスポート",
    "Download your settings and events as a JSON file.": "設定とイベントをJSONファイルとしてダウンロードします。",
    "Export Data": "データのエクスポート",
    "Import Settings": "設定のインポート",
    "Restore your settings from a JSON file. This will overwrite existing data.": "JSONファイルから設定を復元します。これにより、既存のデータが上書きされます。",
    "Select File": "ファイルを選択",
    "Online Meeting": "オンライン会議",
    "You are logged in via your Learning Management System. Please use the specific booking links provided in your course to book appointments.": "学習管理システム経由でログインしています。コースで提供されている特定の予約リンクを使用して予約してください。",
    "Logout": "ログアウト",
    "MyProvider": "私のプロバイダー",
    "Grammatical Gender": "文法上の性",
    "Male": "男性",
    "Female": "女性",
    "Neuter": "中性",
    "gender_help_text": "確認メッセージで正しい文法を使用するために使用されます。",
    "Changelog": "Changelog",
    "Failed to load changelog data.": "変更履歴データを読み込めませんでした。",
    "See what's new and what has been fixed.": "新機能と修正内容をご確認ください。",
    "Reminder setting": "リマインダー設定",
    "Notification type": "通知タイプ",
    "System notification": "システム通知",
    "No reminder": "リマインダーなし",
    "Reminder time": "リマインダー時刻",
    "Reminder settings saved": "リマインダー設定を保存しました",
    "At event start": "イベント開始時",
    "minutes before": "分前",
    "1 day before": "1日前",
    "days before": "日前",
    "1 hour before": "1時間前",
    "hours before": "時間前"
};
//# sourceMappingURL=ja.js.map